// extracted by mini-css-extract-plugin
export default {"container":"base-error-boundary_container__neb-l"};